// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const DemoRentalHistory = t.struct({
    beginDate: t.maybe(t.Number),
    branch: t.maybe(t.String),
    comments: t.maybe(t.String),
    daysOnDemoOrRent: t.maybe(t.Number),
    dealerAccount: t.maybe(t.String),
    dealerCity: t.maybe(t.String),
    dealerName: t.maybe(t.String),
    endDate: t.maybe(t.Number),
    factoryCode: t.maybe(t.String),
    hoursOnDemoOrRent: t.maybe(t.Number),
    pin: t.maybe(t.String),
    productRegistered: t.maybe(t.String),
    registrationDate: t.maybe(t.Number),
    status: t.maybe(t.String),
    tcsmId: t.maybe(t.String),
    tcsmName: t.maybe(t.String)
}, {
    name: 'DemoRentalHistory',
    strict: true
});

export const getDefaultState = () => new DemoRentalHistory({
});

export default DemoRentalHistory;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/demo-rental-history.js